var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        visible: _vm.visible,
        title: "订单详情",
        width: "960px",
        top: "4vh",
        "append-to-body": "",
        "custom-class": "integral-order-detail-dialog",
      },
      on: { close: _vm.handleClose },
    },
    [
      _vm.d
        ? _c(
            "div",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.detailLoading,
                  expression: "detailLoading",
                },
              ],
              staticClass: "integral-order-detail",
            },
            [
              _c(
                "section",
                { staticClass: "detail-section" },
                [
                  _c("div", { staticClass: "section-title" }, [
                    _vm._v("基础信息"),
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-row",
                    { staticClass: "info-grid", attrs: { gutter: 20 } },
                    _vm._l(_vm.baseFieldRows, function (item) {
                      return _c(
                        "el-col",
                        {
                          key: item.label,
                          staticClass: "info-cell",
                          attrs: { span: 12 },
                        },
                        [
                          _c("span", { staticClass: "cell-label" }, [
                            _vm._v(_vm._s(item.label)),
                          ]),
                          _vm._v(" "),
                          _c(
                            "span",
                            { staticClass: "cell-value" },
                            [
                              item.key === "relatedAftersale" &&
                              _vm.d.base.hasAftersale
                                ? [
                                    _c("span", [_vm._v(_vm._s(item.value))]),
                                    _vm._v(" "),
                                    _c(
                                      "el-button",
                                      {
                                        directives: [
                                          {
                                            name: "hasPermi",
                                            rawName: "v-hasPermi",
                                            value: [
                                              "admin:shopintegral:aftersale",
                                            ],
                                            expression:
                                              "['admin:shopintegral:aftersale']",
                                          },
                                        ],
                                        staticClass: "aftersale-link-inline",
                                        attrs: { type: "text", size: "mini" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.goAftersaleList(
                                              _vm.d.base.orderNo
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n                查看 >\n              "
                                        ),
                                      ]
                                    ),
                                  ]
                                : [_vm._v(_vm._s(item.value))],
                            ],
                            2
                          ),
                        ]
                      )
                    }),
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "section",
                { staticClass: "detail-section" },
                [
                  _c("div", { staticClass: "section-title" }, [
                    _vm._v("物流信息"),
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-row",
                    { staticClass: "info-grid", attrs: { gutter: 20 } },
                    [
                      _c(
                        "el-col",
                        { staticClass: "info-cell", attrs: { span: 12 } },
                        [
                          _c("span", { staticClass: "cell-label" }, [
                            _vm._v("收货人："),
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "cell-value" }, [
                            _vm._v(_vm._s(_vm.d.logistics.receiverName)),
                          ]),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { staticClass: "info-cell", attrs: { span: 12 } },
                        [
                          _c("span", { staticClass: "cell-label" }, [
                            _vm._v("收货电话："),
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "cell-value" }, [
                            _vm._v(_vm._s(_vm.d.logistics.receiverPhone)),
                          ]),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        {
                          staticClass: "info-cell info-cell--full",
                          attrs: { span: 24 },
                        },
                        [
                          _c("span", { staticClass: "cell-label" }, [
                            _vm._v("收货地址："),
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "cell-value" }, [
                            _vm._v(_vm._s(_vm.d.logistics.receiverAddress)),
                          ]),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "section",
                { staticClass: "detail-section" },
                [
                  _c("div", { staticClass: "section-title" }, [
                    _vm._v("商品明细"),
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-table",
                    {
                      staticClass: "product-table",
                      attrs: {
                        data: _vm.d.items,
                        border: "",
                        size: "small",
                        "header-cell-style": _vm.tableHeaderStyle,
                      },
                    },
                    [
                      _c("el-table-column", {
                        attrs: {
                          prop: "skuId",
                          label: "skuID",
                          "min-width": "72",
                          align: "center",
                        },
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "code",
                          label: "编号",
                          "min-width": "120",
                          align: "center",
                          "show-overflow-tooltip": "",
                        },
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "name",
                          label: "名称",
                          "min-width": "200",
                          align: "center",
                          "show-overflow-tooltip": "",
                        },
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "attr",
                          label: "销售属性",
                          "min-width": "200",
                          align: "center",
                          "show-overflow-tooltip": "",
                        },
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "qty",
                          label: "数量",
                          "min-width": "64",
                          align: "center",
                        },
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "unitPrice",
                          label: "单价",
                          "min-width": "72",
                          align: "center",
                        },
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "totalPrice",
                          label: "总价",
                          "min-width": "72",
                          align: "center",
                        },
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          label: "图片",
                          "min-width": "72",
                          align: "center",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c(
                                    "div",
                                    { staticClass: "thumb-wrap" },
                                    [
                                      scope.row.image
                                        ? _c("el-image", {
                                            staticClass: "thumb-img",
                                            attrs: {
                                              src: scope.row.image,
                                              fit: "cover",
                                              "preview-src-list": [
                                                scope.row.image,
                                              ],
                                            },
                                          })
                                        : _c(
                                            "span",
                                            { staticClass: "thumb-empty" },
                                            [_vm._v("--")]
                                          ),
                                    ],
                                    1
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          755060570
                        ),
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          label: "发货状态",
                          "min-width": "96",
                          align: "center",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c(
                                    "span",
                                    { staticClass: "tag-ship-pending" },
                                    [_vm._v(_vm._s(scope.row.shipStatus))]
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          2584842969
                        ),
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          label: "关联售后",
                          "min-width": "120",
                          align: "center",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  scope.row.hasAftersale
                                    ? _c(
                                        "div",
                                        { staticClass: "aftersale-wrap" },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "aftersale-plain" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  scope.row
                                                    .aftersaleStatusDesc ||
                                                    "有售后"
                                                )
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "el-button",
                                            {
                                              directives: [
                                                {
                                                  name: "hasPermi",
                                                  rawName: "v-hasPermi",
                                                  value: [
                                                    "admin:shopintegral:aftersale",
                                                  ],
                                                  expression:
                                                    "['admin:shopintegral:aftersale']",
                                                },
                                              ],
                                              staticClass: "aftersale-link",
                                              attrs: {
                                                type: "text",
                                                size: "mini",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.navigateToAftersaleDetail(
                                                    scope.row.aftersaleId
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                查看 >\n              "
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      )
                                    : _c("span", [_vm._v("--")]),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          3917107595
                        ),
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c("section", { staticClass: "detail-section" }, [
                _c("div", { staticClass: "section-title" }, [
                  _vm._v("支付明细"),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "pay-detail-grid" }, [
                  _c("div", { staticClass: "pay-item" }, [
                    _c("span", { staticClass: "pay-lbl" }, [
                      _vm._v("订单总价："),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "pay-val" }, [
                      _vm._v(_vm._s(_vm.d.payment.orderTotal)),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "pay-item" }, [
                    _c("span", { staticClass: "pay-lbl" }, [
                      _vm._v("商品总价："),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "pay-val" }, [
                      _vm._v(_vm._s(_vm.d.payment.goodsTotal)),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "pay-item" }, [
                    _c("span", { staticClass: "pay-lbl" }, [_vm._v("运费：")]),
                    _vm._v(" "),
                    _c("span", { staticClass: "pay-val" }, [
                      _vm._v(_vm._s(_vm.d.payment.freight)),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "pay-item" }, [
                    _c("span", { staticClass: "pay-lbl" }, [
                      _vm._v("卡券抵扣："),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "pay-val" }, [
                      _vm._v(_vm._s(_vm.payCouponDisplay)),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "pay-item" }, [
                    _c("span", { staticClass: "pay-lbl" }, [_vm._v("优惠：")]),
                    _vm._v(" "),
                    _c("span", { staticClass: "pay-val" }, [
                      _vm._v(_vm._s(_vm.d.payment.discount)),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "pay-item" }, [
                    _c("span", { staticClass: "pay-lbl" }, [
                      _vm._v("福豆抵扣："),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "pay-val" }, [
                      _vm._v(_vm._s(_vm.d.payment.fudouDeduct)),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "pay-item" }, [
                    _c("span", { staticClass: "pay-lbl" }, [
                      _vm._v("积分抵扣："),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "pay-val" }, [
                      _vm._v(_vm._s(_vm.d.payment.pointDeduct)),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "pay-item" }, [
                    _c("span", { staticClass: "pay-lbl" }, [
                      _vm._v("积分抵扣金额："),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "pay-val" }, [
                      _vm._v(_vm._s(_vm.d.payment.pointDeductAmount)),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "pay-actual" }, [
                    _c("span", { staticClass: "pay-actual-label" }, [
                      _vm._v("订单实付款："),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "pay-actual-amount" }, [
                      _vm._v(_vm._s(_vm.d.payment.actualPaid)),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "pay-actual-method" }, [
                      _vm._v(
                        "（支付方式：" + _vm._s(_vm.d.payment.payMethod) + "）"
                      ),
                    ]),
                  ]),
                ]),
              ]),
            ]
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }